import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useBreakpoint } from '@frontend/responsiveness';
import { ScheduleFFHelpers } from '@frontend/schedule-helpers';
import { useGetProviderV3 } from './use-get-provider-v3';

export const useShowRequestCalendarLink = ({
  providerId,
  locationId,
  isV2Request,
}: {
  providerId: string | undefined;
  locationId: string | undefined;
  isV2Request: boolean;
}) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const size = useBreakpoint();
  const isSmallDevice = size === 'small' || size === 'xsmall';

  const { isEnabled: isScheduleRequestEventsV3Enabled } = ScheduleFFHelpers.useScheduleRequestEventsV3FeatureFlag();
  const requestProvider = useGetProviderV3({
    providerId: providerId ?? '',
    locationId: locationId ?? '',
  });

  return (
    isScheduleV3FlagEnabled &&
    isScheduleRequestEventsV3Enabled &&
    !requestProvider?.hidden &&
    !isV2Request &&
    !isSmallDevice
  );
};
